<template>
  <Head :title="`${t('heading')} - ${user.email}`"></Head>
  <admin-user-header :user="user" />

  <s-page-block-scrollable size="md" class="flex-1">
    <UserActivityLogTable :user-activities="userActivities.data" />
    <template #footer>
      <s-paginator :paginator="userActivities" :only="reloadProps" />
    </template>
  </s-page-block-scrollable>
</template>
<script setup lang="ts">
import {Head, router} from '@inertiajs/vue3';
import {useI18n} from 'vue-i18n';
import {route} from 'ziggy-js';
import UserActivityLogDto = App.DTOs.UserActivityLogDto;
import IntegerEnumDto = App.DTOs.Users.IntegerEnumDto;
import {usePageParams} from '../../../composables/usePageParams';
import SPaginator from '../../../design-system/SPaginator.vue';
import {LaravelPaginator} from '../../../types/laravel-paginator';
import SPageBlockScrollable from '../../../design-system/SPageBlockScrollable.vue';
import UserActivityLogTable from '../../../components/user-activity-logs/UserActivityLogTable.vue';
import AdminUserHeader from '../../../layouts/AdminUserHeader.vue';
import {User} from '../../../types/entities/user';

const {t} = useI18n({
  inheritLocale: true,
  useScope: 'local',
});

const props = defineProps<{
  user: User;
  userActivities: LaravelPaginator<UserActivityLogDto>;
  activityTypes: IntegerEnumDto[];
}>();

type PropKeys = keyof typeof props;
const reloadProps: PropKeys[] = ['userActivities'];

type PageParams = {
  activityTypes?: string[];
  assignmentId?: string;
  taskId?: string;
};

const params = usePageParams<PageParams>();

const getRouteParams = () => {
  return {
    ...params,
  };
};

const submitSearch = (params: Partial<PageParams>) => {
  router.visit(
    route('admin.users.activity.index', {
      user: props.user.id,
      // Get current route params
      ...getRouteParams(),
      // Empty page when changing filters
      page: undefined,
      // Merge in latest changes.
      ...params,
    }),
    {
      only: reloadProps,
    }
  );
};
</script>
<i18n>
{
  "en": {
    "heading": "Activity Log",
    "search": {
      "activityTypes": "Activity Types"
    }
  },
  "fr": {
    "heading": "Journal d'activités",
    "search": {
      "activityTypes": "Types d'activités"
    }
  }
}
</i18n>
